var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgItemSearch = function SvgItemSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1112_5329",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1112_5329)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49.3877,
    cy: 98.7755,
    r: 15.7143,
    fill: "#FFFAE6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.2857,
    cy: 43.7755,
    r: 5.61224,
    fill: "#F4E9FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 55,
    width: 49.3878,
    height: 49.3878,
    rx: 8,
    fill: "url(#paint0_linear_1112_5329)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7032 96.8173C94.5603 96.8175 94.4187 96.7894 94.2866 96.7348C94.1545 96.6802 94.0344 96.6001 93.9333 96.4991L83.8317 86.3975C83.6477 86.1879 83.5504 85.9161 83.5595 85.6373C83.5686 85.3585 83.6834 85.0936 83.8806 84.8963C84.0779 84.6991 84.3428 84.5843 84.6216 84.5752C84.9004 84.5661 85.1722 84.6634 85.3819 84.8474L95.4834 94.949C95.635 95.1031 95.7376 95.2986 95.7786 95.5108C95.8195 95.7231 95.7969 95.9427 95.7136 96.1422C95.6303 96.3416 95.49 96.5121 95.3103 96.6322C95.1306 96.7523 94.9194 96.8167 94.7032 96.8173Z",
    fill: "url(#paint1_linear_1112_5329)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5445 63.5892C73.856 63.5892 71.2279 64.3864 68.9924 65.8801C66.757 67.3737 65.0147 69.4967 63.9859 71.9806C62.957 74.4644 62.6878 77.1976 63.2123 79.8345C63.7368 82.4713 65.0315 84.8934 66.9325 86.7945C68.8336 88.6955 71.2557 89.9902 73.8926 90.5147C76.5294 91.0392 79.2626 90.77 81.7464 89.7411C84.2303 88.7123 86.3533 86.97 87.847 84.7346C89.3406 82.4992 90.1379 79.871 90.1379 77.1825C90.135 73.5782 88.702 70.1223 86.1533 67.5737C83.6047 65.025 80.1488 63.592 76.5445 63.5892Z",
    fill: "url(#paint2_linear_1112_5329)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5445 67.3651C74.6028 67.3651 72.7047 67.9408 71.0903 69.0196C69.4758 70.0983 68.2175 71.6316 67.4744 73.4255C66.7314 75.2194 66.5369 77.1934 66.9158 79.0978C67.2946 81.0021 68.2296 82.7514 69.6026 84.1244C70.9756 85.4974 72.7249 86.4324 74.6293 86.8113C76.5336 87.1901 78.5076 86.9956 80.3015 86.2526C82.0954 85.5095 83.6287 84.2512 84.7074 82.6367C85.7862 81.0223 86.362 79.1242 86.362 77.1825C86.3599 74.5794 85.3249 72.0834 83.4843 70.2428C81.6436 68.4021 79.1477 67.3671 76.5445 67.3651V67.3651Z",
    fill: "#F7F7F7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_5329",
    x1: 79.6939,
    y1: 55,
    x2: 79.6939,
    y2: 104.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1112_5329",
    x1: 95.7984,
    y1: 84.5746,
    x2: 83.5589,
    y2: 84.5746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1112_5329",
    x1: 90.1379,
    y1: 63.5892,
    x2: 62.9511,
    y2: 63.5892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgItemSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/item-search.52759f5e0d332ac32479523ef483351e.svg";